/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KlassenlehrerInputs */

const de__field_klassenlehrer = /** @type {(inputs: _Field_KlassenlehrerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassenlehrer:in`)
};

/**

* @param {_Field_KlassenlehrerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_klassenlehrer = /** @type {((inputs?: _Field_KlassenlehrerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KlassenlehrerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_klassenlehrer(inputs)
});